import React from 'react';
import { Link } from 'react-router-dom';
import './UtilityPage.css';

interface UtilityPageFrameProps {
  /** Page heading. Omit when the content owns its single h1 (event cards). */
  title?: string;
  /** Optional context column rendered beside the action on desktop. */
  context?: React.ReactNode;
  /** Wide single-column composition for content-heavy surfaces. */
  wide?: boolean;
  /** Optional footer content; defaults to support/copyright. */
  footer?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Neutral utility-page shell for account/auth surfaces. Brand home link in the
 * header, practical support footer, and a two-column context/action layout on
 * desktop that stacks (copy then action) on mobile.
 */
const UtilityPageFrame: React.FC<UtilityPageFrameProps> = ({ title, context, wide, footer, children }) => (
  <div className="utility-page">
    <header className="utility-header">
      <Link to="/" className="utility-brand" aria-label="RidePulse home">
        <img src="/assets/images/logo-256.png" alt="" className="utility-brand-logo" />
        <span className="utility-brand-name">RidePulse</span>
      </Link>
    </header>
    <main className={`utility-main${context ? ' utility-main--split' : ''}${wide ? ' utility-main--wide' : ''}`}>
      {title ? (
        context ? (
          <aside className="utility-context">
            <h1 className="utility-title">{title}</h1>
            {context}
          </aside>
        ) : (
          <h1 className="utility-title utility-title--center">{title}</h1>
        )
      ) : null}
      <div className="utility-action">{children}</div>
    </main>
    <footer className="utility-footer">
      {footer ?? (
        <>
          <Link to="/contact" className="utility-footer-link">Contact support</Link>
          <span className="utility-footer-dot" aria-hidden="true">·</span>
          <span className="utility-footer-note">© {new Date().getFullYear()} RidePulse</span>
        </>
      )}
    </footer>
  </div>
);

export default UtilityPageFrame;
